import { FormEvent, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { returnPathFrom } from '../lib/returnPath';
import { EnvSwitch, EnvBadge } from '../components/EnvSwitch';

export default function Login() {
  const { user, signIn } = useAuth();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // Back to where they were going before sign-in, not always home.
  if (user) return <Navigate to={returnPathFrom(location.state)} replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await signIn(username, password);
    } catch (err: any) {
      setError(err?.message || 'Could not sign in');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <EnvBadge />
      <form className="card login-card" onSubmit={onSubmit}>
        <div className="login-brand"><span className="brand-mark">W</span>
          <div>
            <h1 className="login-title">WPOS Admin</h1>
            <p className="muted login-sub" style={{ marginBottom: 0 }}>Sign in to manage the platform</p>
          </div>
        </div>

        <EnvSwitch />
        <div style={{ height: 16 }} />

        {error && <div className="alert alert-error">{error}</div>}

        <label className="field">
          <span>Username</span>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>

        <label className="field">
          <span>Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        <button className="btn btn-primary btn-block" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
